import { Box, styled } from "@mui/material";

export const SubscribeModalBox = styled(Box)({
    flex: '1 1',
    margin: 'auto 0 !important',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '420px',
  });